// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const pageSizeSelectorWrapper = "Pagination__pageSizeSelectorWrapper__DH50P";
export const pagination = "Pagination__pagination__c+zLB font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const paginatorWrapper = "Pagination__paginatorWrapper__2QfWO";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";